export const CalendarListConstants = {
  pluginId: 'calendar-list',
  defaultPageName: 'default',
  defaultPageId: 'calendar-list-page',
  typeName: 'CalendarList',
};
